<template>
  <modal
    :show.sync="showUnlinkModal"
    :on-close="onClose"
    custom-classes="unlink-modal"
    class="modal-border"
  >
    <woot-modal-header
      :header-title="$t('INBOX_MGMT.ADD.EVOLUTION_API.UNLINK_NUMBER.TITLE')"
      :header-content="
        $t('INBOX_MGMT.ADD.EVOLUTION_API.UNLINK_NUMBER.DESCRIPTION')
      "
    />
    <div class="button-wrapper">
      <woot-button color-scheme="success" @click.prevent="onConfirmUnlink">
        {{
          $t('INBOX_MGMT.ADD.EVOLUTION_API.UNLINK_NUMBER.CONFIRMATION_BUTTON')
        }}
      </woot-button>
      <woot-button class="clear" @click.prevent="onClose">
        {{ $t('INBOX_MGMT.ADD.EVOLUTION_API.UNLINK_NUMBER.REJECT_BUTTON') }}
      </woot-button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../../../../components/Modal.vue';

export default {
  components: { Modal },
  props: {
    showUnlinkModal: {
      type: Boolean,
      default: false,
    },
    onConfirmUnlink: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.unlink-modal.modal-container {
  .modal--close {
    top: 22px;
    right: 22px;
  }
}
</style>

<style scoped lang="scss">
.button-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding: 32px;
}
</style>
